(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-system.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-system.js');
"use strict";

const {
  Article
} = svs.components.tipsen.articleComponents;
const TipsenSystem = _ref => {
  let {
    articleId
  } = _ref;
  return React.createElement(Article, {
    articleId: articleId,
    className: "tipsen-spelguide-article padding-2",
    noArticleMessage: "F\xF6r tillf\xE4llet har vi ingen spelguide"
  });
};
setGlobal('svs.components.tipsen.gameGuideTipsen.TipsenSystem', TipsenSystem);

 })(window);